"use client";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { MdOutlineClose } from "react-icons/md";
import { TbResize } from "react-icons/tb";
import CarouselInner from "./CarouselInner";
import { IoIosResize } from "react-icons/io";
import { GiResize } from "react-icons/gi";
import useFullscreenImage from "@/utils/hooks/useFullScreenImage";

const Carousel: React.FC<CarouselProps> = ({
  images,
  detailedSwiper,
  showPrice,
  showName,
  hidePagination,
  hideZoomIcon = false,
  autoPlay,
}) => {
  const { isImgOpen, openImage, closeImage, containerRef } =
    useFullscreenImage();

  //open the image in fullscreen that is clicked on
  const [clickedOnImageIndex, setClickedOnImageIndex] = useState<number>(0);
  const [hasMounted, setHasMounted] = useState(false);
  const handleClickOnImage = (index: number) => {
    setClickedOnImageIndex(index);
    if (detailedSwiper) {
      openImage();
    }
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) return null;

  return (
    <div
      className={`swiper-container ${images && detailedSwiper && images.length > 1 ? "swiper-detailed-container" : ""}`}
      ref={containerRef}
    >
      {isImgOpen && detailedSwiper && (
        <div className="opened-img-container">
          <MdOutlineClose
            className="close-img-icon"
            onClick={() => {
              closeImage();
              document.body.style.overflow = "auto";
            }}
          />
          <CarouselInner
            images={images}
            imageSizes={{
              width: 1920,
              height: 1080,
            }}
            initialSlideIndex={clickedOnImageIndex}
            isImgOpen={isImgOpen}
          />
        </div>
      )}
      {detailedSwiper && !hideZoomIcon && (
        <div
          title="vollbildmodus"
          className="fullscreen-preview-btn"
          onClick={() => {
            openImage();
            if (window.innerWidth >= 768) {
              document.body.style.overflow = "hidden";
            }
          }}
        >
          <TbResize />
        </div>
      )}
      <CarouselInner
        onClick={handleClickOnImage}
        images={images}
        detailedSwiper={detailedSwiper}
        showPrice={showPrice}
        showName={showName}
        hidePagination={hidePagination}
        autoPlay={autoPlay}
      />
    </div>
  );
};

export default Carousel;
